import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import 'react-dates/initialize'
import { SingleDatePicker } from 'react-dates'
import Moment from 'moment'
import ComboBox from '@components/Form/ComboBox'
import { generateQuantityValues } from '@helpers/ComboBoxHelper'
import './DateRangeForm.module.scss'

// shared props used by both DatePickers
const baseProps = {
  showDefaultInputIcon: true,
  inputIconPosition: 'after',
  displayFormat: 'DD/MM/YYYY',
  numberOfMonths: 1,
  readOnly: true,
  block: true
}

const options = generateQuantityValues()

const DateRangeForm = ({
  startDate,
  startDateFocused,
  onStartDateChange,
  onStartDateFocusChange,
  endDate,
  endDateFocused,
  onEndDateChange,
  onEndDateFocusChange,
  onQuantityChange,
  quantity
}) => (
  <Fragment>
    <div styleName='dateWrapper'>
      <div styleName='label'>Expected Start Date</div>
      <SingleDatePicker
        {...baseProps}
        id='date'
        date={startDate}
        focused={startDateFocused}
        onDateChange={onStartDateChange}
        onFocusChange={onStartDateFocusChange}
      />
    </div>

    <div styleName='dateWrapper'>
      <div styleName='label'>Expected End Date</div>
      <SingleDatePicker
        {...baseProps}
        id='date2'
        date={endDate}
        focused={endDateFocused}
        onDateChange={onEndDateChange}
        onFocusChange={onEndDateFocusChange}
        isOutsideRange={(day) => (Moment().add(1, 'day')).isAfter(day, 'day')}
      />
    </div>

    <div styleName='quantityWrapper'>
      <div styleName='label'>Quantity</div>
      <ComboBox options={options} change={onQuantityChange} selectedValue={quantity} />
    </div>
  </Fragment>
)

DateRangeForm.propTypes = {
  startDate: PropTypes.instanceOf(Moment).isRequired,
  startDateFocused: PropTypes.bool.isRequired,
  onStartDateChange: PropTypes.func.isRequired,
  onStartDateFocusChange: PropTypes.func.isRequired,
  endDate: PropTypes.instanceOf(Moment).isRequired,
  endDateFocused: PropTypes.bool.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  onEndDateFocusChange: PropTypes.func.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  quantity: PropTypes.string.isRequired
}

export default DateRangeForm



// WEBPACK FOOTER //
// ./src/components/DateRangeForm/DateRangeForm.js